class AddEditQuestionsController {

    constructor() {
        this.stackableOrder = 1;
        $(document).on("click", '#addeditAddQuestion', function () {
            if (!world.isFinishedOrExpired() && world.can_send_new_question) {
                // baseController.stackSimpleMenu({text: 'TR_SELECCIONA_UNA_CATEGORIA',backAction:'QUIZFIT'});
                api.getnewGameCategories(world.token, null, 'ADDQUESTION');
                return false;
            }
        });

        $(document).on("click", '#addeditReviewQuestion', function () {
            if (!world.isFinishedOrExpired() && (world.can_review_question || user.isSupervisor()) && !$('#addeditReviewQuestion').hasClass('bg-disabled')) {
                api.getnewGameCategories(world.token, null, 'EDITQUESTION');
                return false;
            }
        });

        $(document).on("click", '#sendQuestionBtn', function () {
            var errorMsg = '';
            var categoryId = $("#addQuestionQuestion").attr('data-category');
            var template, context;

            if ($("#addQuestionQuestion").val() == '') {
                errorMsg += Translator.trans('TR_ERROR_PREGUNTA_VACIA') + '<br>';
            }
            if ($("#addQuestionAnswer0Inp").val() == '') {
                errorMsg += Translator.trans('TR_ERROR_RESPUESTA_CORRECTA_VACIA') + '<br>';
            }
            if ($("#addQuestionAnswer1Inp").val() == '') {
                errorMsg += Translator.trans('TR_ERROR_RESPUESTA_INCORRECTA_VACIA') + '<br>';
            }
            if (errorMsg != '') {
                notify(errorMsg, "danger");
                return false
            }

            var question = {};
            question.title = $("#addQuestionQuestion").val();
            question.correct_answer = $("#addQuestionAnswer0Inp").val();
            question.answer2 = $("#addQuestionAnswer1Inp").val();

            if ($("#addQuestionAnswer2Inp").val() != '') {
                question.answer3 = $("#addQuestionAnswer2Inp").val();
            }
            if ($("#addQuestionAnswer3Inp").val() != '') {
                question.answer4 = $("#addQuestionAnswer3Inp").val();
            }

            if (world.categories) {
                //that could be better
                $.each(world.categories, function (index, value) {
                    if (value.category.id == categoryId) {
                        context = {color: value.category.color};
                    }
                });
            }

            template = Handlebars.compile($("#worldAddQuestionSplashScreen").html());
            $("#jugar").html(template(context));
            loadingQuestionsScreenController.draw(context);

            if (world.token) {
                api.addQuestion(world.token, categoryId, question);
            }
        });
    };
}